import { render, staticRenderFns } from "./PortletDiscoveredAssets.vue?vue&type=template&id=c705a304"
import script from "./PortletDiscoveredAssets.vue?vue&type=script&lang=js"
export * from "./PortletDiscoveredAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports